// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"6bdbef5a","780":"2c6347ad"}[chunkId] + ".chunk.js";
};